export default {
    data: {
        server_url: "https://gtjnapi.gtjn.net",
        // server_url: "https://tsdkzapi.6cd.com.cn",
        img_url: "https://gtjnapi.gtjn.net",
        // web_url: "http://project.6cd.com.cn:31000",
        // server_url: "https://isrpapi.6cd.com.cn",
        // map_server_url: "https://apis.map.qq.com",
    }
}
